import { Component, ViewChild, OnInit, AfterViewInit } from '@angular/core';
import { AuthService } from '@services/auth.service';
import { AlertifyService } from '@services/alertify.service';
import { Router } from '@angular/router';
import { CircleProgressComponent, CircleProgressOptions } from 'ng-circle-progress';
import { UserClassesService } from '@services/user-classes.service';
import { TranslateService } from '@ngx-translate/core';
import { ConfigurationService } from '@app/core/services/configuration.service';
import { Bootstrap_Modal_Service } from '@services/bootstrap-modal.service';

@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.css']
})
export class NavMenuComponent implements OnInit {
  isExpanded = false;
  isAdmin: boolean = false;
  isLoading: boolean = true;
  classManual: string = "";
  classFAQ: string = "";

  options = new CircleProgressOptions();
  //circle
  @ViewChild('circleProgress', { static: true }) circleProgress: CircleProgressComponent;

  constructor(
    public authService: AuthService,
    private alertify: AlertifyService,
    private router: Router,
    public userClassesService: UserClassesService,
    private translate: TranslateService,
    private config: ConfigurationService,
    private bootstrap_modal: Bootstrap_Modal_Service
  ) {
      this.options = new CircleProgressOptions();
      this.options.percent = 0;
      this.options.radius = 20;
  }

  // Get translation in component
  /*
  getMessage() {
    this.translate.get('MESSAGES.SUCCESS').subscribe((res: string) => {//.get is async
      console.log(res);
    });
  }
  */
  // Switch language
  switchLanguage(lang: string) {
    this.translate.use(lang);
  }

  /*
  // Get instant translation (only if already loaded)
  getInstantTranslation() {
    return this.translate.instant('MESSAGES.SUCCESS');//instant is sync
  }
  */
  async ngOnInit() {
    try {
      this.isAdmin = await this.authService.getAdminStatus();
    } catch (error) {
      console.error('Error fetching admin status', error);
    } finally {
      this.isLoading = false;
    }
    this.classManual = this.config.getClassManualUrl();    
    this.classFAQ = this.config.getClassFAQ_URL();
  }


  collapse() {
    this.isExpanded = false;
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }


  // ngAfterViewInit(): void {
  //   this.isAdmin = null;
  //   if (this.authService.loggedIn()) {
  //       const ROLE_ADMIN = 'ROLE_ADMIN';
  //       this.isAdmin = this.authService.isAdmin;
  //       console.log(`IsAdminc: ${this.isAdmin}`);
  //   }
  // }



  // if user is loggedin
  loggedIn() {
    return this.authService.loggedIn();
  }

  courseCompleted() {
    if (this.authService.loggedIn()) {
        if (this.authService.getCourseCompleted() == "true") {
          return true;
        }
    }
    return false;
  }

  logout() {
    this.authService.logout()
    this.authService.decodedToken = null;
    // this.authService.currentUser = null;
    this.translate.get(["ALERTIFY.LOGOUT", "BOOTSTRAP.MODAL.SUCCESS"]).subscribe((text: string) => {
      this.alertify.success(text['ALERTIFY.LOGOUT']);

      this.bootstrap_modal.open({
        modal_header_html: text['BOOTSTRAP.MODAL.SUCCESS'],
        modal_body_html: text['ALERTIFY.LOGOUT'],
        modal_color_variant: "success"
      })
    })

    this.router.navigate(['/login']);
  }
  getPercentage() {
    return localStorage.getItem('percentage_for_entire_course');
  }

  /**
   * Download the certificate using the proper API endpoint with correct MIME type
   */
  downloadCertificate(): void {
    if (this.authService.loggedIn()) {
      const currentUser = this.authService.returnCurrentUser();
      if (currentUser?.id) {
        this.userClassesService.GetCertificatePdf(currentUser.id).subscribe({
          next: (blob: Blob) => {
            // Create a blob URL and trigger download
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `certificate_${currentUser.id}.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
          },
          error: (error) => {
            console.error('Error downloading certificate:', error);
            this.translate.get(["ALERTIFY.DOWNLOAD_CERTIFICATE", "BOOTSTRAP.MODAL.ERROR"]).subscribe((text: string) => {
              this.alertify.error(text)

              this.bootstrap_modal.open({
                modal_header_html: text['BOOTSTRAP.MODAL.ERROR'],
                modal_body_html: text['ALERTIFY.DOWNLOAD_CERTIFICATE'],
                modal_color_variant: "danger"
              })
            });
          }
        });
      }
    }
  }

}
